/*
SaiKrishna 10/06/2022 3075154998 Removed unnecessary console.log statements
Suresh Peddavoora 10/28/2022 3075154998  Added Class Name for Text Fields and Buttons
Lalitha  11/9/2022  3075154998 Rename Button Cancel to Reset
*/
import React, {useEffect, useContext} from 'react';
import {Formik} from 'formik';
import {Button, Grid, TextField, FormHelperText} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import * as Yup from 'yup';
import {getDropDownData} from '../../../../../../redux/reducers/EnableFramework/Filter';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';


const ConditionForm = ({
  setConditionData,
  conditionData,
  setFilterOpen,
  handleConditionClose,
  conditionRowData,
  isConditionEditMode,
  setIsConditionEditMode,
  conditionCode,
  ruleGroupSNo,
  type,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {

    recordCodeData,

  } = useSelector(({filter}) => filter);

  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.value === option) {
          label = item;
        }
      });
    return label;
  };

  let initialValues = {
    recordCode: conditionRowData?.recordCode ?
      getObject(conditionRowData?.recordCode?.recordCode, recordCodeData) :
      {},
    recordType: conditionRowData?.recordType ? getObject(conditionRowData?.recordType?.value, [
      {value: 'Import', valueCode: 'HI'},
      {value: 'Import', valueCode: 'TI'},
      {value: 'DEMOGRAPHICS In', valueCode: 'DI'},
    ]) : {},
    description: conditionRowData?.description ? conditionRowData?.description : '',
    // code: isConditionEditMode
    //   ? conditionRowData && conditionRowData.code
    //   : ruleGroupSNo
    //     ? ruleGroupSNo > 9
    //       ? "R" + ruleGroupSNo
    //       : "R0" + ruleGroupSNo
    //     : isConditionEditMode && conditionRowData && conditionRowData.code
    //       ? conditionRowData.code
    //       : "",
    // operator: isConditionEditMode && conditionRowData?.operator ? conditionRowData?.operator : "",
    // toField: isConditionEditMode && conditionRowData?.toField ? conditionRowData?.toField : "",
    // fieldCode:
    //   isConditionEditMode && conditionRowData?.fieldCode ? conditionRowData?.fieldCode : "",
    // srcField: isConditionEditMode && conditionRowData?.srcField ? conditionRowData?.srcField : "",
    // dateFormat:
    //   isConditionEditMode && conditionRowData?.dateFormat ? conditionRowData?.dateFormat : "",
  };


  useEffect(() => {
    initialValues = {
      recordCode: conditionRowData?.recordCode ?
        getObject(conditionRowData?.recordCode?.recordCode, recordCodeData) :
        {},
      recordType: conditionRowData?.recordType ? getObject(conditionRowData?.recordType?.value, [
        {value: 'Import', valueCode: 'HI'},
        {value: 'Import', valueCode: 'TI'},
        {value: 'DEMOGRAPHICS In', valueCode: 'DI'},
      ]) : '',
      description: conditionRowData?.description ? conditionRowData?.description : '',
      // code: isConditionEditMode
      //   ? conditionRowData && conditionRowData.code
      //   : ruleGroupSNo
      //     ? ruleGroupSNo > 9
      //       ? "R" + ruleGroupSNo
      //       : "R0" + ruleGroupSNo
      //     : isConditionEditMode && conditionRowData && conditionRowData.code
      //       ? conditionRowData.code
      //       : "",
      // operator: isConditionEditMode && conditionRowData?.operator ? conditionRowData?.operator : "",
      // toField: isConditionEditMode && conditionRowData?.toField ? conditionRowData?.toField : "",
      // fieldCode:
      //   isConditionEditMode && conditionRowData?.fieldCode ? conditionRowData?.fieldCode : "",
      // srcField: isConditionEditMode && conditionRowData?.srcField ? conditionRowData?.srcField : "",
      // dateFormat:
      //   isConditionEditMode && conditionRowData?.dateFormat ? conditionRowData?.dateFormat : "",
    };
  }, [conditionRowData]);

  const handleSubmit = (data) => {
    const copiedData = [...conditionData];
    if (!isConditionEditMode) {
      copiedData.push({...data});
      setConditionData(copiedData);
      setFilterOpen(false);
    } else {
      const updatedActionData = copiedData.map((item, i) => {
        if (i === conditionCode) {
          return {
            ...item,
            code: data?.code,
            operator: data?.operator,
            fieldName: data?.fieldName,
            fieldCode: data?.fieldCode,
            dateorField: data?.dateorField,
            dateFormat: data?.dateFormat,
            seqNo: i + 1,
            srcField: data?.srcField,
            toField: data?.toField,
          };
        } else {
          return {...item};
        }
      });
      setConditionData(updatedActionData);
      setFilterOpen(false);
      setIsConditionEditMode(false);
    }
  };
  useEffect(() => {
    dispatch(getDropDownData());
  }, []);
  const schema = Yup.object().shape({
    recordCode: Yup.mixed().test('recordType', 'Record Code is required', (value) => {
      if (!value?.recordCode) {
        return false;
      } else {
        return true;
      }
    }),
    description: Yup.string().required('Description is required'),
    // code:
    //   conditionRowData?.code === currentRuleCode && isConditionEditMode
    //     ? ""
    //     : Yup.string()
    //       .notOneOf(
    //         conditionData.map((data) => data.code),
    //         "Rule code already exists"
    //       )
    //       .required("Rule Code is required").nullable(),
  });
  return (
    <div className={classes.dialoguecardStyles}>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        validationSchema={schema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            resetForm,
            handleChange,
            handleSubmit,
            handleReset,
            handleBlur,
            setFieldValue,
          } = props;
          return (
            <div>
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                <div className="global-field-textfields">
                  <Grid container spacing={2}>
                    {type?.valueCode === 'I' ? (
                      <Grid item xs={6} className="form-group">
                        <TextField
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Error File Name`}
                          label="Error File Name"
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="errorFileName"
                          value={values.errorFileName}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.errorFileName}
                          error={Boolean(touched.errorFileName && errors.errorFileName)}
                        />
                        <FormHelperText style={{color: 'red'}}>
                          {touched.errorFileName && errors.errorFileName && errors.errorFileName}
                        </FormHelperText>
                      </Grid>
                    ) : null}
                    <Grid item xs={6} xl={6} md={6} sm={6} className="pl-md-1 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        {...props}
                        id="recordCode"
                        options={recordCodeData || []}
                        size="small"
                        autoHighlight
                        getOptionDisabled={(option) => option.recordCode === null}
                        getOptionLabel={(option) => {
                          return option && option.recordCode && option.description ?
                            option.recordCode + ' - ' + option.description :
                            option.description === null ?
                              option.recordCode :
                              '';
                        }}
                        name="recordCode"
                        value={values?.recordCode}
                        onChange={(e, value) => {
                          handleChange(e);
                          setFieldValue('recordCode', value);
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            margin="dense"
                            {...params}
                            className={` ${classes.labelName} ${classes.selectLabel}`}
                            variant="outlined"
                            fullWidth
                            required
                            placeholder="Enter Record Code"
                            label="Record Code"
                            name="recordCode"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                            touched={touched.recordCode}
                            error={Boolean(touched.recordCode && errors.recordCode)}
                          />
                        )}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched?.recordCode && errors?.recordCode}
                      </FormHelperText>
                    </Grid>
                    <Grid item xs={6} xl={6} md={6} sm={6} className="pl-md-1 form-group">
                      <TextField
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Description`}
                        label="Description"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        required
                        touched={touched.description}
                        error={Boolean(touched.description && errors.description)}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.description && errors.description}
                      </FormHelperText>
                    </Grid>
                    <Grid item xs={6} xl={6} md={6} sm={6} className="pl-md-1 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        {...props}
                        id="recordType"
                        options={[
                          {value: 'Import', valueCode: 'HI'},
                          {value: 'Import', valueCode: 'TI'},
                          {value: 'DEMOGRAPHICS In', valueCode: 'DI'},
                        ]}
                        size="small"
                        autoHighlight
                        value={values?.recordType}
                        getOptionDisabled={(option) => option.valueCode === null}
                        getOptionLabel={(option) => {
                          return option && option.valueCode && option.value ?
                            option.valueCode + ' - ' + option.value :
                            option.value === null ?
                              option.valueCode :
                              '';
                        }}
                        onChange={(e, value) => {
                          handleChange(e);
                          setFieldValue('recordType', value);
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            margin="dense"
                            {...params}
                            className={` ${classes.labelName} ${classes.selectLabel}`}
                            variant="outlined"
                            fullWidth
                            label="Record Type"
                            name="recordType"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            placeholder="Select Record Type"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </div>
                <div className="text-center">
                  <div className="row justify-content-center mb-1">
                    <Button
                      type="button"
                      onClick={() => resetForm()}
                      variant="outlined"
                      className={`reset-btn mx-1 ${classes.buttonRoot}`}
                    >
                      Reset
                    </Button>
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`search-btn mx-1 ${classes.buttonRoot}`}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default ConditionForm;
